import { useAuth } from "./useAuth";
interface LogoutOptions {
  redirectTo?: string;
  stayLoggedOut?: boolean;
}
export default function useLogout() {
  const auth = useAuth();

  const logout = async ({
    redirectTo = "/auth/login",
    stayLoggedOut,
  }: LogoutOptions) => {
    try {
      await auth.logout({ redirectTo, stayLoggedOut });
    } catch (err) {
      console.error("Logout error:", err);
      if (!stayLoggedOut) return window.location.href = redirectTo;
    }
  };

  return logout;
}
